module.exports = __webpack_public_path__ + "img/shubham_photo.7daa9382.png";